import {Component, inject, output} from '@angular/core';
import {Router} from "@angular/router";
import {UserStorageService} from "../../../../../services/user-storage.service";

@Component({
  selector: 'app-service-request-popup',
  templateUrl: './service-request-popup.component.html',
  styleUrl: './service-request-popup.component.css',
  standalone: false
})
export class ServiceRequestPopupComponent {
  close = output();

  private readonly router = inject(Router);
  private readonly userStorageService = inject(UserStorageService);

  getServiceRequestList(): any[] {
    const storedData = this.userStorageService.getValue('serviceRequest');
    if (storedData) {
      try {
        const parsedData: any[] = JSON.parse(storedData);
        if (parsedData && parsedData.length > 0) {
          return parsedData;
        }
      } catch (error) {
      }
    }
    return [];
  }

  closePopup() {
    this.close.emit();
  }

  closeAndNavigate() {
    this.router.navigate(['/service-request']);
    this.close.emit();
  }

  deleteItemFormServiceRequest(item: any) {
    this.userStorageService.removeFromLocalStorageArray("serviceRequest", item);

    const storedData = this.userStorageService.getValue('serviceRequest');
    if (!storedData || storedData.length === 0) {
      this.close.emit();
    }
  }
}
